module.exports = __webpack_public_path__ + "img/terroir-wavy-4.2beaed84.jpg";